import http from '../../http'

export async function getOrders(code, legacyId, page, pageQuantity, orderBy) {
  return http.get(
    `/order/list?OrderCodeOrCpfCnpj=${code}&LegacyId=${legacyId}&Page=${page}&PageQuantity=${pageQuantity}&OrderBy=${orderBy}`
  )
}

export async function getAccessValidation(entityLegacyId, objectName) {
  return http.get(
    `/Auth/trusthub-validate-object-access?entityLegacyId=${entityLegacyId}&objectName=${objectName}`
  )
}

export async function getFinalizationStatusList(entityLegacyId, orderCode) {
  return http.get(
    `/order/finalization-by-responsibility?LegacyEntityId=${entityLegacyId}&OrderCode=${orderCode}`
  )
}

export async function finalizationByParam(
  entityLegacyId,
  orderCode,
  finalizationTypeId
) {
  return http.post('/order/finalization-by-responsibility', {
    entityLegacyId: entityLegacyId,
    orderCode: orderCode,
    statusId: finalizationTypeId,
    observation: 'Finalização por Responsabilidade MyClearSale'
  })
}

export async function prioritizeList(orderCode, entityLegacyId) {
  return http.get(
    `/order/priorities-list?OrderCode=${orderCode}&EntityLegacyId=${entityLegacyId}`
  )
}

export async function reanalysisList(orderCode, entityLegacyId) {
  return http.get(
    `/order/reanalysis-list?OrderCode=${orderCode}&EntityLegacyId=${entityLegacyId}`
  )
}

export async function prioritizeOrder(
  orderCode,
  entityLegacyId,
  priorityTypeId
) {
  return http.patch(`/order/prioritize`, {
    orderCode: orderCode,
    entityLegacyId: entityLegacyId,
    priorityTypeId: priorityTypeId
  })
}

export async function reanalyzeOrder(
  orderCode,
  entityLegacyId,
  reanalisisTypeId
) {
  return http.patch(`/order/reanalyze`, {
    orderCode: orderCode,
    entityLegacyId: entityLegacyId,
    reanalisisTypeId: reanalisisTypeId
  })
}
